import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { Alert, Badge, Card, Spinner } from '../../components/ui';
import { type MessageKey, t } from '../../i18n';
import { api } from '../../lib/api';
import { errorMessage } from '../../lib/errors';
import type { TeamMember } from './data';
import { PeopleNav } from './PeopleNav';

/** Mi equipo: las personas que le reportan directamente, para ver su ficha o pedir un cambio de sus datos. */
export function TeamPage() {
  const team = useQuery({ queryKey: ['usuarios', 'equipo'], queryFn: () => api<TeamMember[]>('/api/usuarios/equipo') });
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-tinta">{t('us.equipo')}</h1>
        <p className="max-w-2xl text-sm text-slate-600">{t('us.equipo_descripcion')}</p>
      </div>
      <PeopleNav />
      <Card className="p-0">
        {!team.data ? (
          <div className="p-5">{team.error ? <Alert>{errorMessage(team.error)}</Alert> : <Spinner label={t('comun.cargando')} />}</div>
        ) : team.data.length === 0 ? (
          <p className="p-5 text-sm text-slate-500">{t('us.equipo_vacio')}</p>
        ) : (
          <ul className="divide-y divide-slate-100">
            {team.data.map((u) => (
              <li key={u.id} className="flex flex-wrap items-baseline justify-between gap-2 px-4 py-3 text-sm">
                <div>
                  <Link to={`/usuarios/personas/${u.id}`} className="font-medium text-marca hover:underline">
                    {u.fullName}
                  </Link>
                  {u.status !== 'activo' && (
                    <span className="ml-1.5">
                      <Badge tone="amber">{t(`us.usuario_${u.status}` as MessageKey)}</Badge>
                    </span>
                  )}
                  <span className="block text-xs text-slate-500">
                    {u.email} · {u.organization}
                  </span>
                </div>
                <span className="text-slate-700">{[u.position, u.department].filter(Boolean).join(' · ') || '—'}</span>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
